export const GET_BINDING_ENTITY = 'constants/binding/GET_BINDING_ENTITY';
export const BINDING_ENTITY_SUCCESS = 'constants/binding/BINDING_ENTITY_SUCCESS';
export const BINDING_ENTITY_ERROR = 'constants/binding/BINDING_ENTITY_ERROR';